import { render, staticRenderFns } from "./deleteCommercialStory.vue?vue&type=template&id=7fbaa21b"
import script from "./deleteCommercialStory.vue?vue&type=script&lang=js"
export * from "./deleteCommercialStory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports